import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { concatMap, from, map } from "rxjs";

import { UnsavedChangesActions } from "./unsaved-changes.actions";

export const replayUnsavedChanges = createEffect((
  actions$ = inject(Actions),
) => {
    return actions$.pipe(
      ofType(UnsavedChangesActions.replayTriggered),
      concatMap(({ changes }) => from(changes).pipe(
        map((change) => ({
          ...change.action,
          metadata: {
            changeId: change.id,
          },
        })),
      )),
    );
  }, { functional: true, dispatch: true });
